import createAction from 'redux-actions/es/createAction'

export const update = createAction('BATCHES/STORE/UPDATE')
